import type { FragmentType } from 'src/gql';
import TrackedButton from 'src/components/tracked/tracked-button';
import { RoadmapStage } from 'src/constants/client-roadmap';
import { graphql, unmaskFragment } from 'src/gql';
import { isRequiredTaskStatus } from 'src/utils/client-roadmap';

import HouseholdOnboardingCallToAction from './household-onboarding-call-to-action';

export const RoadmapCallToActionFragment = graphql(/* GraphQL */ `
  fragment RoadmapCallToAction on Task {
    status
    type
    ...HouseholdOnboardingCallToAction
  }
`);

function RoadmapCallToAction({
  roadmapStage,
  taskFrags,
}: {
  readonly roadmapStage: RoadmapStage;
  readonly taskFrags: FragmentType<typeof RoadmapCallToActionFragment>[];
}) {
  const onboardingTaskFrags = taskFrags
    .filter((taskFrag) => {
      const task = unmaskFragment(RoadmapCallToActionFragment, taskFrag);
      return task.type === 'onboarding_flow' && isRequiredTaskStatus({ status: task.status });
    })
    .map((taskFrag) => unmaskFragment(RoadmapCallToActionFragment, taskFrag));
  switch (roadmapStage) {
    case RoadmapStage.SIT_BACK_AND_WAIT:
    case RoadmapStage.INTRO_CALL:
    case RoadmapStage.COMPLETED:
      return null;
    case RoadmapStage.INTAKE_FLOW:
      return (
        <TrackedButton
          elementName="roadmap-intake-flow-call-to-action-open-button"
          onClick={() => (window.location.href = '/welcome')}
          className="w-full"
        >
          Open
        </TrackedButton>
      );
    case RoadmapStage.ACCOUNT_SETUP:
      if (
        taskFrags.filter((taskFrag) => {
          const task = unmaskFragment(RoadmapCallToActionFragment, taskFrag);
          return isRequiredTaskStatus({ status: task.status });
        }).length === 0
      ) {
        return (
          <TrackedButton
            elementName="roadmap-account-setup-call-to-action-in-review-button"
            disabled
            className="w-full"
          >
            In review
          </TrackedButton>
        );
      }
      return (
        <TrackedButton
          elementName="roadmap-account-setup-call-to-action-open-button"
          // TODO: support returning to dashboard after task
          onClick={() => (window.location.href = '/account-setup')}
          className="w-full"
        >
          Open
        </TrackedButton>
      );
    case RoadmapStage.ONBOARDING_FLOW:
      return <HouseholdOnboardingCallToAction requriedOnboardingTaskFrags={onboardingTaskFrags} />;
  }
}

export default RoadmapCallToAction;
